import { FC } from 'react';
import { List, ListItem, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import Meta from '@bizapp-lp/home/organisms/Meta';
import { Complete } from '@bizapp-lp/home/templates/Complete';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiListItem-root': {
        display: 'block',
        textAlign: 'center',
      },
    },
  }),
);

const Sitemap: FC = () => {
  const classes = useStyle();
  return (
    <>
      <Meta>
        <title>Root 社内向けサイトマップ</title>
      </Meta>
      <Complete
        heading1="Root 社内向けサイトマップ"
        heading2="各ページ確認用"
        description=""
      >
        <Container className={classes.root}>
          <List>
            <ListItem>
              <Link component={RouterLink} to="/terms">
                HUE Works Suite / HUE Works Suite DX Solutions利用規約
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/privacy">
                個人情報の取扱いについて
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/contact">
                お問い合わせ
              </Link>
            </ListItem>
            <ListItem>
              <Link
                component={RouterLink}
                to="/complete-contact"
                state={{ valid: true }}
              >
                お問い合わせ 完了
              </Link>
            </ListItem>
            <ListItem>
              <Link component={RouterLink} to="/invalid">
                無効なページ
              </Link>
            </ListItem>
            <ListItem>
              <Link href="/chatbot/">Chatbot</Link>
            </ListItem>
            <ListItem>
              <Link href="/chatbot/internal/sitemap">Chatbotサイトマップ</Link>
            </ListItem>
            <ListItem>
              <Link href="/ebm/">EBM</Link>
            </ListItem>
            <ListItem>
              <Link href="/ebm/internal/sitemap">EBMサイトマップ</Link>
            </ListItem>
            <ListItem>
              <Link href="/ess/">ESS</Link>
            </ListItem>
            <ListItem>
              <Link href="/ess/internal/sitemap">ESSサイトマップ</Link>
            </ListItem>
          </List>
        </Container>
      </Complete>
    </>
  );
};

export default Sitemap;
